import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useApi } from '../../context/ApiProvider';
import { Context } from '../../context/Context';
import "./Login.css";
import { useLocale } from '../../localization/LocaleProvider';
import LanguageSelect from '../LanguageSelect';

export default function Login() {

  const Api = useApi();
  const appContext = useContext(Context);

  return (
    <main className="loginScreen">
      <section className="loginForm">
        <p>
          <img src="/images/Rolf_Logo_Color_RGB.svg" height="48" alt="Rolf" />
        </p>

        <section className="card">
          {appContext.state.otp ?
            <OtpForm />
            :
            <LoginForm />
          }
        </section>
      </section>
    </main>
  )
}

const OtpForm = () => {

  const Api = useApi();
  const appContext = useContext(Context);
  const { translate } = useLocale();

  const [otp, setOtp] = useState();
  const [loginError, setLoginError] = useState();

  const checkOtp = (e) => {
    e.preventDefault();

    Api.otp(otp, appContext.state.sessionId).then(result => {
      appContext.dispatch({ type: 'login' });
    }).catch(e => {
      setLoginError(e.error.message);
      console.log(e);
      //appContext.showToast('error', e.error.message);
    }).finally(() => {

    });
  }

  return (
    <form onSubmit={checkOtp}>
      <h1>{translate("Login")}</h1>
      {loginError && <p className="formControlError">{loginError}</p>}
      <div className="formGroup">
        <label>{translate("Security code")}</label>
        <input name="otp" type="text" className="formControl" required defaultValue="" onChange={e => setOtp(e.target.value)} placeholder={translate("Enter 6 digit security code")} autoFocus autoComplete="off" />

      </div>
      <p className='spaceBetween'>
        <button type="submit">{translate("Submit")}</button>
        <button type="reset" onClick={() => appContext.dispatch({ type: 'sessionEnd' })} >{translate("Cancel")}</button>
      </p>
    </form>
  )
}

const LoginForm = () => {

  const Api = useApi();
  const appContext = useContext(Context);
  const { translate } = useLocale();

  const [username, setUserName] = useState();
  const [password, setPassword] = useState();

  const [loginError, setLoginError] = useState();
  const [isLoggingIn, setIsLoggingIn] = useState();
  const [requestPassError, setRequestPassError] = useState(false);
  const [requestPassSuccess, setRequestPassSuccess] = useState(false);
  const [showForgotPasswordForm, setShowForgotPasswordForm] = useState(false);

  const login = (e) => {
    e.preventDefault();

    setIsLoggingIn(true);
    setLoginError(false);

    Api.login({ username, password }).then(result => {
      appContext.dispatch({ type: 'sessionStart', sessionId: result.sessionId });
    }
    ).catch(err => {
      setLoginError(err?.error?.message);
    }).finally(() => {
      setIsLoggingIn(false);
    });
  }

  const resetPassword = (e) => {
    e.preventDefault();
    Api.requestPasswordReset({ "email": username })
    .then(() => {
      setRequestPassSuccess(translate("A link to reset your password has been sent to your email address."));
      setUserName("");
    })
    .catch((e) => {
      console.log(e);
      setRequestPassError(translate("An error occurred while requesting a password."));
    })
    .finally(() =>
    {
      setTimeout(() => {
        setRequestPassError(false);
        setRequestPassSuccess(false);
      }, 5000);
    });

    
  }

  return (
    showForgotPasswordForm ? //Visa forgotPasswordForm
    <form onSubmit={resetPassword}>
      <h2>{translate("Request password reset")}</h2>
      <div className='formGroup'>
        <label>{translate("E-mail:")}</label>
        <input name="username" type="email" className="formControl" required autoComplete="email" onChange={e => setUserName(e.target.value)} value={username} placeholder={translate("Enter e-mail")} />
      </div>
      <p><button type="submit">{translate("Submit")}</button></p>

      {requestPassSuccess && <p className='formControlSuccess'>{requestPassSuccess}</p>}
      {requestPassError && <p className='formControlError'>{requestPassError}</p>}

      <p><a onClick={() => setShowForgotPasswordForm(false)}>{translate("Back to login")}</a></p>
    </form>
    : 
    <>
      <form onSubmit={login}>
        <h1>{translate("Login")}</h1>
        {loginError && <p className="formControlError">{loginError}</p>}
        <div className="formGroup">
          <label>{translate("Username / E-mail")}</label>
          <input name="username" type="email" className="formControl" required autoComplete="email" onChange={e => setUserName(e.target.value)} placeholder={translate("Enter username or e-mail")} />
        </div>
        <div className="formGroup">
          <label>{translate("Password")}</label>
          <input name="password" type="password" className="formControl" required autoComplete="current-password" onChange={e => setPassword(e.target.value)} placeholder={translate("Enter password")} />
        </div>
        <p className='spaceBetween'>
          <button type="submit">{translate("Log in")}</button>
          <LanguageSelect />
        </p>
      </form>
      <p>{translate("Have you forgotten your password?")} <a onClick={() => setShowForgotPasswordForm(true)}>{translate("Press here")}</a></p>
    </>
  
  )
}